import { SalesOrder, Shipment } from '@laco/backend-interfaces';
import { PartnerAddressType } from '@laco/backend-interfaces/dist/partners';
export const samplePackingListHeader: Shipment.ShipmentHeader = {
  _id: 'shipmentHeader_id',
  shipFromLocation: 'Reno',
  isKit: false,
  shipmentNumber: 'PL072680',
  salesOrderHeaderId: '',
  salesOrderNumber: '0121684',
  customer: {
    _id: 'customer_id',
    accountNumber: 'SIE001',
    name: 'SIEMENS INDUSTRY, INC',
    displayName: 'SIEMENS INDUSTRY, INC',
    address: {
      active: true,
      approved: true,
      address: 'SIEMENS INDUSTRY, INC\nPO BOX 4356 MC-IMA030\nPORTLAND OR 97208',
      type: [PartnerAddressType.BILL_TO],
      display: 'SIEMENS INDUSTRY, INC\nPO BOX 4356 MC-IMA030\nPORTLAND OR 97208',
      _id: '',
    },
  },
  customerPO: '4509087430',
  shippingMethod: 'SIEMENS TRAFFIC',
  shipTo: '7318 FRENCH ROAD\nSACRAMENTO CA 95828',
  attention: '',
  status: Shipment.ShipmentHeaderStatus.PACKAGED,
  packagedAt: new Date(),
  shippedAt: new Date(),
  lines: [
    {
      _id: 'shipmentLine_id-1',
      shipmentHeader: '',
      shipmentNumber: 'PL072680',
      salesOrderLine: {
        _id: '',
        header: '',
        lineNumber: 300,
        product: '',
        price: 0,
        releases: [],
        needReview: false,
        status: SalesOrder.SalesOrderLineStatus.CLOSED,
        total: 0,
        quantity: 1,
        qtyOpen: 1,
        isKit: false,
      },
      salesOrderRelease: '',
      orderLineNumber: 300,
      orderReleaseNumber: 1,
      productRef: '',
      shipFromLocationRef: '',
      shipFromLocationName: 'Reno, NV',
      customerProductCode: 'RS:A8178501',
      productDescription: 'H321B ROOF CROSSOVER',
      productRevision: 'E',
      productUnitOfMeasure: 'EA',
      productManufacturerName: '',
      productUnitPrice: 0,
      requiredQuantity: 1,
      packagedQuantity: 1,
      dueDate: new Date().toDateString(),
      shipDate: new Date().toDateString(),
      packagedAt: new Date(),
      shippedAt: new Date(),
    },
  ],
  // trackingNumber: 'Tracking',
};
export const sampleHitachiPackingListHeader: Shipment.ShipmentHeader = {
  shipFromLocation: 'Reno',
  shipmentNumber: 'PL245034',
  salesOrderNumber: '2009311',
  customer: {
    _id: 'customer_id',
    displayName: 'Hitachi Rail CD U.S. Ltd.',
    accountNumber: 'HIT001',
    name: 'Hitachi Rail CD U.S. Ltd.',
    address: {
      address: '300 Crossways Park Drive\nWoodbury NY 11797',
      display: '300 Crossways Park Drive\nWoodbury NY 11797',
      active: true,
      approved: true,
      type: [PartnerAddressType.BILL_TO],
      _id: '',
    },
  },
  customerPO: 'PO10023368',
  shippingMethod: 'UPS GROUND 8685W1',
  shipTo: 'Hitachi Rail CD U.S. Ltd.\n2118 Energy Drive\nApex NC 27502',
  packagedAt: new Date('2026-09-03T17:17:24-0700'),
  shippedAt: new Date('2026-09-03T17:17:24-0700'),
  attention: 'Josh LaMantia',
  lines: [
    {
      _id: 'shipmentLine_id-1',
      shipmentNumber: 'PL245034',
      salesOrderLine: {
        lineNumber: 1,
        quantity: 1,
        qtyOpen: 0,
        _id: '',
        header: '',
        product: '',
        price: 0,
        releases: [],
        needReview: false,
        status: SalesOrder.SalesOrderLineStatus.CLOSED,
        total: 0,
        isKit: false,
      },
      orderLineNumber: 1,
      orderReleaseNumber: 1,
      customerProductCode: '108-1117-0002',
      productDescription: 'ASMBLY SR2685 APC SECTION 1',
      productRevision: 'B',
      productUnitOfMeasure: 'EA',
      requiredQuantity: 1,
      packagedQuantity: 1,
      dueDate: '2026-09-03T17:17:24-0700',
      shipDate: '2026-09-03T17:17:24-0700',
      packagedAt: new Date('2026-09-03T17:17:24-0700'),
      shippedAt: new Date('2026-09-03T17:17:24-0700'),

      shipmentHeader: '',
      salesOrderRelease: '',
      productRef: '',
      shipFromLocationRef: '',
      shipFromLocationName: 'Reno, NV',
      productManufacturerName: '',
      productUnitPrice: 0,
    },
  ],

  _id: 'shipmentHeader_id',
  isKit: false,
  salesOrderHeaderId: '',
  status: Shipment.ShipmentHeaderStatus.PACKAGED,
};
